import { markRaw } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { createPinia } from 'pinia';

const pinia = createPinia();

pinia.use(({ store }) => {
  store.$router = markRaw(useRouter());
  store.$route = markRaw(useRoute());
});

export default pinia;
